<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import router from "@/router";
import {useStore} from "vuex";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";

export default {
  name: "CategoryPage",
  components: {BottomNavigation, LoadingPage},

  setup() {

    let store = useStore()
    store.commit('set_storePage_filter', 'delete')

    let background = ref(false)
    let loading = ref(false)

    let filter = store.state.filter.categoryPage
    let filter_products = ref({
      brand_id: null,
      price_from: '',
      price_to: '',
      exist: false,
    })
    let check_filter = ref(false)
    let select_cat = ref(useRoute().params.cid)
    let select_sub_cat = ref(null)

    let categories = ref([])
    let subcategory = ref([])
    let products = ref([])

    let text_search = ref('')

    let sort = ref()
    let page = ref('category')

    let brands = ref([])

    if (store.state.filter.categoryProducts !== null) {
      filter_products.value = store.state.filter.categoryProducts
      set_filter()
    } else {
      load_category()
    }

    function get_brands() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'brands'}, 'info').then((res) => {

        loading.value = false
        brands.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_brands, true)
      })
    }
    get_brands()

    function load_category() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'products', true).then((res) => {

        loading.value = false

        categories.value = res.data
        if (filter !== null) {
          select_cat.value = filter.select_cat
          select_sub_cat.value = filter.select_sub_cat
          chang_categories('filter')
        } else if (select_cat.value != 0) {
          chang_categories('cat', select_cat.value)
        } else {
          chang_categories('new')
        }
        store.commit('set_categoryProducts_filter', 'delete')
        check_filter.value = false
        page.value = 'category'
        filter_products.value = {
          brand_id: null,
          price_from: '',
          price_to: '',
          exist: false,
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_category)
      })

    }

    function open_search() {

      let input_search = document.getElementById('input_search')

      if (input_search.style.width !== '15rem') {
        input_search.style.width = '15rem'
      } else {
        if (text_search.value.trim().length !== 0) {
          router.push({name: 'SearchBy', params: {text: text_search.value}})
        } else {
          input_search.style.width = '2.6rem'
        }

      }

    }

    function open_sort() {

      let filter_sort = document.getElementById('filter_sort')

      if (filter_sort.style.height != '26rem') {
        filter_sort.style.height = '26rem'
        background.value = true
      } else {
        filter_sort.style.height = '0'
        background.value = false
      }

    }

    function chang_categories(type, id) {

      if (type === 'cat') {
        products.value = []

        categories.value.forEach((item) => {
          if (item.id == id) {
            subcategory.value = item.subcategory
            select_cat.value = item.id
            if (item.subcategory[0]) {
              select_sub_cat.value = item.subcategory[0].id
              products.value = item.subcategory[0].products
            }
          }
        })

        let i = {
          select_cat: select_cat.value,
          select_sub_cat: select_sub_cat.value
        }
        store.commit('set_categoryPage_filter', i)

      }

      if (type === 'sub_cat') {

        products.value = []
        subcategory.value.forEach((item) => {
          if (item.id == id) {
            products.value = item.products
            select_sub_cat.value = id
          }
        })

        let i = {
          select_cat: select_cat.value,
          select_sub_cat: select_sub_cat.value
        }
        store.commit('set_categoryPage_filter', i)

      }

      if (type === 'filter') {

        products.value = []

        categories.value.forEach((item) => {
          if (item.id === select_cat.value) {
            subcategory.value = item.subcategory
            subcategory.value.forEach((sub) => {
              if (sub.id === select_sub_cat.value) {
                products.value = sub.products
              }
            })
          }
        })

      }

      if (type === 'new') {

        products.value = []
        if (categories.value[0]) {
          select_cat.value = categories.value[0].id
          if (categories.value[0].subcategory[0]) {
            subcategory.value = categories.value[0].subcategory
            select_sub_cat.value = subcategory.value[0].id
            products.value = subcategory.value[0].products
          }

        }
      }
    }

    function sort_prod(type) {

      if (type === 'new') {

        let sortedProducts = products.value.slice().sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        products.value = sortedProducts;
        sort.value = type;
        open_sort()
      }

      if (type === 'old') {

        let sortedProducts = products.value.slice().sort((a, b) => {
          return new Date(a.created_at) - new Date(b.created_at);
        });
        products.value = sortedProducts;
        sort.value = type;
        open_sort()
      }

      if (type === 'sold') {
        let i
        i = products.value.sort((a, b) => b.sold - a.sold);
        products.value.shops = i
        sort.value = type
        open_sort()
      }

      if (type === 'views') {
        let i
        i = products.value.sort((a, b) => b.views - a.views);
        products.value.shops = i
        sort.value = type
        open_sort()
      }

    }

    function set_filter() {
      let data = {
        brand_id: filter_products.value.brand_id,
        price_from: filter_products.value.price_from,
        price_to: filter_products.value.price_to,
        exist: filter_products.value.exist,
      }
      if (!data.exist) delete (data.exist)
      if (data.brand_id === null) delete (data.brand_id)
      if (data.price_from.length === 0) delete (data.price_from)
      if (data.price_to.length === 0) delete (data.price_to)
      loading.value = true
      FreeWorld.Heisenberg(data, 'products', true).then((res) => {

        loading.value = false

        categories.value = res.data
        if (filter !== null) {
          select_cat.value = filter.select_cat
          select_sub_cat.value = filter.select_sub_cat
          chang_categories('filter')
        } else if (select_cat.value != 0) {
          chang_categories('cat', select_cat.value)
        } else {
          chang_categories('new')
        }
        store.commit('set_categoryProducts_filter', filter_products.value)
        if (filter_products.value.exist === false && filter_products.value.brand_id === null && filter_products.value.price_from.length === 0 && filter_products.value.price_to.length === 0) {
          check_filter.value = false
        } else {
          check_filter.value = true
        }
        page.value = 'category'

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_category)
      })
    }


    return {

      open_sort,
      open_search,
      background,
      loading,
      subcategory,
      categories,
      select_cat,
      select_sub_cat,
      chang_categories,
      products,
      text_search,
      sort,
      sort_prod,
      page,
      filter_products,
      set_filter,
      load_category,
      check_filter,
      brands,

    }
  }
}
</script>


<template>


  <LoadingPage v-if="loading"></LoadingPage>

  <div v-if="page === 'category'" id="main" :class="loading ? 'activeClass':'' " class="bg-main">


    <div @click="open_sort" v-if="background" class="bg_dialog"></div>


    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <div class="position-relative">
            <span v-if="check_filter" class="p-2 rounded-pill bg-danger position-absolute z-1"></span>
            <img @click="page = 'filter'" class="icon-size-4 icon_shadow border_icon"
                 src="../assets/img/icon_filter_bgLight.svg" alt="">
          </div>
          <img @click="open_sort" class="icon-size-4 icon_shadow border_icon mx-2"
               src="../assets/img/filter_sort_bgLight.svg" alt="">
          <form @submit="open_search" class="position-relative">
            <input v-model="text_search" id="input_search"
                   class="input_search font-5 text-center rounded-pill p-2 position-absolute bg-white shadow-custom"
                   placeholder="جستجو" type="text">
            <img @click="open_search" class="icon-size-4 position-relative" src="../assets/img/icon_search_bgLight.svg"
                 alt="">
          </form>
        </div>

        <div class="d-flex align-items-center">
          <p class="font-color font-4 font-bold">دسته بندی محصولات</p>
          <router-link :to="{name:'HomePage'}">
            <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
          </router-link>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">

      <div v-if="categories.length > 0" class="mb-4">
        <div class="list_category py-3 mb-3">

          <div @click="chang_categories('cat' , item.id)" v-for="item in categories" :key="item.id"
               :class="select_cat == item.id ? 'select_cat':'' "
               class="animate__animated animate__fadeIn div_category mx-2 d-flex flex-column justify-content-between align-items-center p-2 bg-white rounded-3 shadow-custom">
            <div class="img_category animated-background mb-2">
              <img class="img_category" :src="item.pic" alt="">
            </div>
            <div class="overflow-hidden w-100 d-flex justify-content-center">
              <p class="font-5 text-center" :class="item.name.length > 14 ? 'txtoverflow':''">{{ item.name }}</p>
            </div>
          </div>

        </div>

        <div class="list_category py-3">

          <div v-for="item in subcategory" :key="item.id" @click="chang_categories('sub_cat' , item.id)"
               :class="select_sub_cat == item.id ? 'select_cat':'' "
               class="animate__animated animate__fadeIn div_category mx-2 d-flex flex-column justify-content-between align-items-center p-2 bg-white rounded-3 shadow-custom">
            <div class="overflow-hidden w-100 d-flex justify-content-center">
              <p class="font-5 text-center" :class="item.name.length > 10 ? 'txtoverflow':''">{{ item.name }}</p>
            </div>
          </div>

        </div>
      </div>

      <div v-else class="mb-4">
        <div class="list_category py-3 mb-3">

          <v-skeleton-loader type="ossein" style="height: 104px ;background: #FFFFFF00"
                             class="animate__animated animate__fadeIn ml-2 div_category rounded-3"></v-skeleton-loader>
          <v-skeleton-loader type="ossein" style="height: 104px ;background: #FFFFFF00"
                             class="animate__animated animate__fadeIn ml-2 div_category rounded-3"></v-skeleton-loader>
          <v-skeleton-loader type="ossein" style="height: 104px ;background: #FFFFFF00"
                             class="animate__animated animate__fadeIn ml-2 div_category rounded-3"></v-skeleton-loader>

        </div>

        <div class="d-flex">

          <v-skeleton-loader style="width: 100px;height: 60px ; background: #FFFFFF00" type="chip"
                             class="animate__animated animate__fadeIn font-4 ml-1"></v-skeleton-loader>
          <v-skeleton-loader style="width: 100px;height: 60px ; background: #FFFFFF00" type="chip"
                             class="animate__animated animate__fadeIn font-4 ml-1"></v-skeleton-loader>
          <v-skeleton-loader style="width: 100px;height: 60px ; background: #FFFFFF00" type="chip"
                             class="animate__animated animate__fadeIn font-4 ml-1"></v-skeleton-loader>

        </div>
      </div>


      <div v-if="products.length === 0 && !loading" style="height: 40vh"
           class="d-flex justify-content-center w-100 animate__animated animate__fadeIn">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <img src="../assets/img/product-not-found.png" class="mb-3 w-40" alt="">
          <p class="font-4 font-bold">متاسفانه محصولی در این دسته بندی وجود ندارد!</p>
        </div>
      </div>

      <div v-else class="">

        <router-link :to="{name:'DetailsProducts',params:{pid:item.id}}" v-for="item in products" :key="item.id"
                     class="animate__animated animate__fadeInRight text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
          <div class="w-60 ml-3 d-flex flex-column justify-content-around">
            <div class="overflow-hidden">
              <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
            </div>

            <div class="overflow-hidden">
              <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
            </div>
            <div class="d-flex align-items-center">
              <p v-if="item.shops !== 0" class="font-5 d-flex font-color font-bold mr-3">
                <span class="">{{ item.price.toLocaleString() }}</span>
                <span class="mr-1">تومان</span>
              </p>
              <p v-else class="font-5 d-flex font-color-red font-bold mr-3">ناموجود</p>
            </div>

            <div class="div_hr my-2"></div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center">
                <img class="icon_shop ml-2" src="../assets/img/store_color.svg" alt="">
                <p class="font-5">{{ item.shops }} فروشگاه</p>
              </div>

              <div class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</div>
            </div>

          </div>

          <div class="img_prod rounded-3 animated-background">
            <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
          </div>
        </router-link>

      </div>


    </div>


    <div id="filter_sort" class="filter_sort rounded-top-5 max_width bg-white shadow-custom py-3 px-5">

      <div @click="open_sort" class="hr_sort rounded-pill mb-4"></div>

      <div class="">

        <p class="font-4 text-center">مرتب سازی بر اساس :</p>
        <hr>
        <p @click="sort_prod('new')" :class="sort === 'new' ? 'font-bold font-color font-3':'font-4' "
           class="text-center">جدیدترین</p>
        <hr>
        <p @click="sort_prod('old')" :class="sort === 'old' ? 'font-bold font-color font-3':'font-4' "
           class="text-center">قدیمی ترین</p>
        <hr>
        <p @click="sort_prod('sold')" :class="sort === 'sold' ? 'font-bold font-color font-3':'font-4' "
           class="text-center">پر فروش ترین</p>
        <hr>
        <p @click="sort_prod('views')" :class="sort === 'views' ? 'font-bold font-color font-3':'font-4' "
           class="font-4 text-center">پر بازدید ترین</p>

      </div>

    </div>

    <BottomNavigation></BottomNavigation>

  </div>

  <div v-if="page === 'filter'" id="main" :class="loading ? 'activeClass':'' " class="bg-main">


    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <div @click="load_category" class="d-flex align-items-center">
        <p class="font-color font-4 font-bold">حذف تمامی فیلترها</p>
        <img class="svg-arrow" src="../assets/img/Recycle_Bin_color.svg" alt="">
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">فیلتر ها</p>
        <img @click="page = 'category'" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3 animate__animated animate__fadeIn">

      <div class="p-3 rounded-4 d-flex align-items-center justify-content-between bg-white mb-3">
        <div class="d-flex align-items-center">
          <p class="font-4">برند</p>

          <div style="width: 1px;height: 26px" class="mx-2 bg-unavailable"></div>
        </div>


        <select v-model="filter_products.brand_id" class="w-100 border-0 font-4">
          <option :value="null">همه برند ها</option>
          <option v-for="item in brands" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>

      </div>

      <div class="bg-white p-3 rounded-4 mb-3">
        <p class="mb-3 font-4">محدوده قیمت (تومان)</p>

        <div class="d-flex align-items-center justify-content-around">
          <input v-model="filter_products.price_from"
                 class="w-45 p-2 font-4 rounded-pill bg-color-blue-light shadow-custom text-center" type="tel"
                 placeholder="از">
          <input v-model="filter_products.price_to"
                 class="w-45 p-2 font-4 rounded-pill bg-color-blue-light shadow-custom text-center" type="tel"
                 placeholder="تا">
        </div>
      </div>

      <div class="p-3 rounded-4 mb-5 d-flex align-items-center bg-white">

        <input v-model="filter_products.exist" id="mojod" class="ml-2" type="checkbox">
        <label class="font-4" for="mojod">فقط کالاهای موجود</label>

      </div>

      <div class="d-flex justify-content-center w-100 mt-5">
        <v-btn @click="set_filter" class="rounded-4 h-100 p-3 bg-color shadow-custom font-4 text-white w-90">ثبت</v-btn>
      </div>

    </div>

  </div>


</template>


<style scoped>

.icon_filter {
  width: 40px;
  height: 40px;
}

.list_category {
  overflow-x: scroll;
  display: flex;
}

.img_category {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.div_category {
  min-width: 7rem;
}


@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}

.img_prod {
  width: 40%;
  height: 11.3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 1.2rem;
}


.div_all_cat {
  position: fixed;
  top: 10%;
}

.input_search {
  left: -1px;
  top: 50%;
  transform: translate(0, -50%);
  width: 2.6rem;
  transition: .5s;
}

.filter_sort {
  height: 0;
  width: 100%;
  position: fixed;
  bottom: -50px;
  overflow: hidden;
  transition: .5s;
  z-index: 6;
}

.hr_sort {
  width: 60%;
  height: 8px;
  background-color: #DCF4FF;
  margin: 0 auto;
}

.select_cat {
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
}


</style>